var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirRecuperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5355 14.3452C14.6681 14.3046 14.907 10.394 12.2054 10.8959C9.7916 11.3456 10.7369 14.3755 12.5355 14.3452ZM14.3577 8.92626C14.7596 9.34594 15.2316 9.70194 15.6807 10.0746C19.4052 7.99549 24.3415 8.03262 24.9536 12.5375C25.3349 15.3559 23.9613 20.8197 21.8063 20.5826C20.784 20.4682 20.0003 17.9583 19.3247 17.133C18.2464 15.8211 17.2985 15.3361 16.1779 14.509C15.4648 14.6227 15.4989 15.4741 14.8527 15.6574C17.367 19.6518 16.8959 24.8901 11.3782 25.0149C8.56336 25.0797 4.06674 23.6726 4.42197 21.731C4.57837 20.8951 6.11563 20.5915 6.90761 20.0896C8.41406 19.1349 9.69587 17.4178 10.5495 15.9866C10.2544 15.5124 9.42619 15.5669 9.39064 14.8361C5.96113 16.9115 0.868987 16.9843 0.118247 12.8667C-0.444097 9.78559 1.0735 4.23341 3.09822 4.32999C4.2222 4.38145 4.77601 6.61849 5.41655 7.44822C6.49574 8.8466 7.76404 9.60254 8.89252 10.5679C9.3923 10.1886 9.62098 9.54004 10.2179 9.25359C7.17302 4.53066 8.68327 -0.616879 15.3494 0.0603424C17.2798 0.258198 20.9501 1.44745 20.6501 3.17998C20.4979 4.04613 18.0995 4.87562 17.3369 5.47647C15.9357 6.58865 15.3432 7.78166 14.3577 8.92626Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirRecuperation);
export default __webpack_public_path__ + "static/media/air-recuperation.c3415b119c993a64893e35b2176cb80f.svg";
export { ForwardRef as ReactComponent };